import { enviroment } from "../../../../enviroment";

// The size a NEW cart row starts with. Flag cartSizeBlankDefaultEnabled on
// (Nichlas 7/10: "not M - blank as a start"): "" so the field shows its
// placeholder and a bag/cap row never carries a size nobody chose. Off: the
// historical "M". Rows already stored in the cart are never touched - this
// is only read where a row is CREATED.
export const LEGACY_DEFAULT_ROW_SIZE = "M";

export function defaultRowSize(): string {
  return enviroment.cartSizeBlankDefaultEnabled ? "" : LEGACY_DEFAULT_ROW_SIZE;
}

// The size of a row that came back from an Excel upload (the cart's "Upload
// Excel file" - the API's design template or, with ExcelNameListFallbackEnabled,
// a bare name list). Flag cartSizeBlankDefaultEnabled on: the uploaded size as
// the API gave it - an empty cell (API flag OrderExcelSizeBlankEnabled) or a
// name list without sizes stays "" exactly like a typed row, and is never
// filled from another row. Off: today's chain - the uploaded size, else the
// size of the row the dialog was opened from, else "M".
export function templateRowSize(
  uploadedSize: string | null | undefined,
  firstRowSize: string | undefined,
): string {
  if (enviroment.cartSizeBlankDefaultEnabled) {
    return uploadedSize ?? "";
  }
  return uploadedSize || firstRowSize || defaultRowSize();
}
